import { createContext, Dispatch, SetStateAction } from 'react';

import { CarQuotationCoverage, CarQuotationServiceRequest, CarReQuotationServiceRequest, SelectOption, Version } from '../../../../../../../../../shared/interfaces';
import { WebDiscountRateResponse } from '../../../../../../../../../shared/interfaces/services/get-car-web-discount-rate-response-service';
import { CardScoringQuestions } from '../../../../../../../../../shared/interfaces/services/get-car-scoring-questions-response';
import { CarAccessoriesTable } from './StepTwoFormProvider';
import { QuotationButton } from '../../../../../shared';

interface StepTwoFormContextProps {
  accessoriesList:                  Array<SelectOption>;

  accessoryTable:                   CarAccessoriesTable;
  setAccessoryTable:                Dispatch<SetStateAction<CarAccessoriesTable>>;

  showWebDiscountRate:              WebDiscountRateResponse | undefined;

  activeKey:                        any;
  setActiveKey:                     Dispatch<SetStateAction<any>>;

  isLoadingAccessoriesList:         boolean;
  isLoadingModelList:               boolean;
  isLoadingVersionList:             boolean;
  isLoadingBrandList:               boolean;


  keyTabToDelete:                   number | null;
  setKeyTabToDelete:                Dispatch<SetStateAction<number | null>>;

  showModal:                        boolean;
  setShowModal:                     Dispatch<SetStateAction<boolean>>;

  tabs:                             any[];
  yearList:                         Array<SelectOption>;

  carFormValues:                    any;
  setCarFormValues:                 Dispatch<SetStateAction<any>>;

  brandsByYear:                     Array<{ year: string, brands: Array<SelectOption> }>;
  modelsByBrandAndYear:             Array<{ brand: string, year: string, models: Array<SelectOption> }>;
  versionsByYearBrandAndModel:      Array<{ brand: string, year: string, model: string, versionOptions: Array<SelectOption>, versions: Array<Version> }>;

  scoringQuestions:                 Array<CardScoringQuestions>;

  goodResultTypesList:              Array<SelectOption>;

  labelButton:                      QuotationButton;
  setLabelButton:                   Dispatch<SetStateAction<QuotationButton>>;

  //* Methods
  removeTab:                        (id?: any) => void;
  
  addNewTab:                        (id?: number) => void;
  
  duplicateTab:                     (id?: number) => void;
  
  getBrandsByYear:                  (year: string) => Promise<void>;

  getModelByBrandAndYear:           (year: string, brand: string) => Promise<void>;
  
  getVersionByYearBrandAndModel:    (year: string, brand: string, model:string) => Promise<void>;

  generateTitleForTabs:             (yearSelected: string, brandSelected: string, modelSelected: string) => string | undefined;

  generateCarQuotationForm:         (componentId: string) => CarQuotationServiceRequest;

  generateCarReQuotationForm:       (componentId: string) => CarReQuotationServiceRequest;

  executeCarQuotations:             () => Promise<void>;

  executeCarReQuotations:           () => Promise<void>;

  getEPVAndCommisionValue:          (componentId: string, coverage: CarQuotationCoverage) => { porcentajeComision: string; porcentajeExtraPrima: string }

  getVersionSelectedByVehicle:      (componentId: string) => Version | undefined;

  removeVehicleInfo:                (componentId: string) => Promise<void>;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);
